import PartyTarget from "../../../../model/character/PartyTarget";
import MineControl from "../../../../model/control/MineControl";
import { MineModes } from "../../../../model/control/MineModes";
import Page from "../../../framework/Page";
import ParentView from "../../../framework/ParentView";
import TargetDepthView from "./TargetDepthView";
import MineModeOption from "./MineModeOption";

export default class MineControlView extends ParentView {
    /**
     * 
     * @param {string} parentId 
     * @param {MineControl} mineControl 
     * @param {PartyTarget} partyTarget
     */
    constructor(parentId, mineControl, partyTarget) {
        super(parentId, 'mineControl');

        this.addView(new MineModeOption(this.elementId, this.elementId + '_up', mineControl, MineModes.MINE_SHALLOWER, 'Mine', 'Shallower'));
        this.addView(new MineModeOption(this.elementId, this.elementId + '_down', mineControl, MineModes.MINE_DEEPER, 'Mine', 'Deeper'));
        this.addView(new MineModeOption(this.elementId, this.elementId + '_current', mineControl, MineModes.MINE_CURRENT, 'Mine', 'Current'));
        this.addView(new MineModeOption(this.elementId, this.elementId + '_auto', mineControl, MineModes.MINE_AUTO, 'Mine', 'Auto'));

        this.addView(new TargetDepthView(this.elementId, partyTarget));
    }

    /**
     * @override
     */
    initializeView() {
        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'mine-control-panel');

        super.initializeView();        
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }

}